export const BRANDING_SHELL =
  "rounded-xl border bg-background shadow-none";

// `--color-border` was never a real token — themes/styles/light.js and
// dark.js only ever set `--color-primary-border` (the app's actual border
// color, mapped to the `border-border-primary` utility class elsewhere).
// This always fell through to the hardcoded fallback below, in both themes,
// which reads as a faint line in light mode and is invisible in dark mode.
export const BRANDING_SHELL_STYLE = {
  borderColor: "rgb(var(--color-primary-border, 214 217 222))",
};

export const BRANDING_ROW_PADDING = "px-4 py-3";
export const BRANDING_CARD_PADDING = "p-4";
export const BRANDING_GAP = "gap-2.5";
export const BRANDING_STACK_GAP = "space-y-3";

// A tile nested inside a card — an asset row, a history entry, a preview
// swatch — reads as "inside" the card when its corners are a size down from
// the card's own BRANDING_SHELL radius.
export const BRANDING_TILE_RADIUS = "rounded-lg";

export const BRANDING_TITLE = "text-sm font-semibold text-text-primary";
export const BRANDING_SUBTITLE = "mt-0.5 text-xs text-text-secondary";
export const BRANDING_LABEL = "text-[11px] font-medium text-text-secondary";

// The small icon badge every BrandingSectionHeader draws next to its title.
export const BRANDING_SECTION_ICON_WRAP =
  "flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-background-secondary text-text-secondary";

export const DARK_TILE_BG = "#14161a";
export const DARK_TILE_BORDER = "rgba(255,255,255,0.06)";
export const DARK_LOGO_BG = "#191c20";
export const DARK_LOGO_BORDER = "rgba(255,255,255,0.05)";
export const DARK_CHROME_BG = "#1b1e23";
export const DARK_DOT = "rgba(255,255,255,0.18)";
export const DARK_SKELETON = "rgba(255,255,255,0.08)";

export const LIGHT_TILE_BG = "#f8fafc";
export const LIGHT_LOGO_BG = "#ffffff";
export const LIGHT_CHROME_BG = "#ffffff";
export const LIGHT_DOT = "rgba(0,0,0,0.15)";
export const LIGHT_SKELETON = "rgba(0,0,0,0.06)";

// The light/dark preview toggle (BrandingPreview) and any other segmented
// pair on this page — one pill track, one active/inactive pair of classes,
// so a second toggle reads the same as the first instead of forking its own.
export const BRANDING_PILL_TRACK =
  "inline-flex items-center gap-0.5 rounded-full bg-background-secondary p-1";
export const BRANDING_PILL_BUTTON =
  "flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors";
export const BRANDING_PILL_BUTTON_ACTIVE = "bg-background text-text-primary shadow-sm";
export const BRANDING_PILL_BUTTON_INACTIVE = "text-text-secondary hover:text-text-primary";
